var _defs, _g, _g2, _g3, _g4, _circle, _path, _path2, _g5, _g6, _g7, _path3, _g8, _g9, _g10, _g11, _g12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingBikeIncreasedafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1169.47 874.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parkingBikeIncreased_after_svg__cls-3{fill:#343a50}.parkingBikeIncreased_after_svg__cls-13,.parkingBikeIncreased_after_svg__cls-14,.parkingBikeIncreased_after_svg__cls-26,.parkingBikeIncreased_after_svg__cls-29,.parkingBikeIncreased_after_svg__cls-31,.parkingBikeIncreased_after_svg__cls-32,.parkingBikeIncreased_after_svg__cls-35,.parkingBikeIncreased_after_svg__cls-36,.parkingBikeIncreased_after_svg__cls-37,.parkingBikeIncreased_after_svg__cls-39,.parkingBikeIncreased_after_svg__cls-40,.parkingBikeIncreased_after_svg__cls-43,.parkingBikeIncreased_after_svg__cls-45,.parkingBikeIncreased_after_svg__cls-48,.parkingBikeIncreased_after_svg__cls-49,.parkingBikeIncreased_after_svg__cls-7{stroke:#343a50}.parkingBikeIncreased_after_svg__cls-13,.parkingBikeIncreased_after_svg__cls-26,.parkingBikeIncreased_after_svg__cls-29,.parkingBikeIncreased_after_svg__cls-31,.parkingBikeIncreased_after_svg__cls-32,.parkingBikeIncreased_after_svg__cls-34,.parkingBikeIncreased_after_svg__cls-35,.parkingBikeIncreased_after_svg__cls-36,.parkingBikeIncreased_after_svg__cls-37,.parkingBikeIncreased_after_svg__cls-38,.parkingBikeIncreased_after_svg__cls-39,.parkingBikeIncreased_after_svg__cls-40,.parkingBikeIncreased_after_svg__cls-41,.parkingBikeIncreased_after_svg__cls-43,.parkingBikeIncreased_after_svg__cls-45,.parkingBikeIncreased_after_svg__cls-7{stroke-miterlimit:10}.parkingBikeIncreased_after_svg__cls-13,.parkingBikeIncreased_after_svg__cls-14,.parkingBikeIncreased_after_svg__cls-26,.parkingBikeIncreased_after_svg__cls-29,.parkingBikeIncreased_after_svg__cls-7{stroke-width:2px}.parkingBikeIncreased_after_svg__cls-7{fill:#8a2519}.parkingBikeIncreased_after_svg__cls-13{fill:#7fc3ca}.parkingBikeIncreased_after_svg__cls-14,.parkingBikeIncreased_after_svg__cls-48,.parkingBikeIncreased_after_svg__cls-49{stroke-linejoin:round}.parkingBikeIncreased_after_svg__cls-11{fill:#eb9a6b}.parkingBikeIncreased_after_svg__cls-12{fill:#cc825c}.parkingBikeIncreased_after_svg__cls-14,.parkingBikeIncreased_after_svg__cls-20{fill:#dedede}.parkingBikeIncreased_after_svg__cls-14,.parkingBikeIncreased_after_svg__cls-48,.parkingBikeIncreased_after_svg__cls-49{stroke-linecap:round}.parkingBikeIncreased_after_svg__cls-19{mix-blend-mode:multiply}.parkingBikeIncreased_after_svg__cls-26{fill:#3b3b3b}.parkingBikeIncreased_after_svg__cls-25{fill:#2cb4c3}.parkingBikeIncreased_after_svg__cls-29{fill:#353535}.parkingBikeIncreased_after_svg__cls-31{fill:#191919}.parkingBikeIncreased_after_svg__cls-32,.parkingBikeIncreased_after_svg__cls-37{fill:#857d7a}.parkingBikeIncreased_after_svg__cls-36,.parkingBikeIncreased_after_svg__cls-40,.parkingBikeIncreased_after_svg__cls-45,.parkingBikeIncreased_after_svg__cls-48,.parkingBikeIncreased_after_svg__cls-49{stroke-width:3px}.parkingBikeIncreased_after_svg__cls-34,.parkingBikeIncreased_after_svg__cls-38,.parkingBikeIncreased_after_svg__cls-41,.parkingBikeIncreased_after_svg__cls-49{fill:none}.parkingBikeIncreased_after_svg__cls-34,.parkingBikeIncreased_after_svg__cls-38,.parkingBikeIncreased_after_svg__cls-41{stroke:#191919}.parkingBikeIncreased_after_svg__cls-34{stroke-width:2.63px}.parkingBikeIncreased_after_svg__cls-35,.parkingBikeIncreased_after_svg__cls-36{fill:#46bea9}.parkingBikeIncreased_after_svg__cls-37{stroke-width:1.33px}.parkingBikeIncreased_after_svg__cls-38{stroke-width:2.64px}.parkingBikeIncreased_after_svg__cls-39,.parkingBikeIncreased_after_svg__cls-40{fill:#ffcf00}.parkingBikeIncreased_after_svg__cls-41{stroke-width:3.32px}.parkingBikeIncreased_after_svg__cls-43,.parkingBikeIncreased_after_svg__cls-45{fill:#f84c34}.parkingBikeIncreased_after_svg__cls-48{fill:#f9ffff}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fahrradstellpl\\xE4tze_Nachher"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Himmel"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260.56,
    height: 498.22,
    x: -28.28,
    y: -206.41,
    fill: "#a5d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.25-205.38v496.16H-27.25v-496.16h1258.5m2.06-2.06H-29.31v500.28h1262.62v-500.28z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Wiese"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260.16,
    height: 614.68,
    x: -28.33,
    y: 261.1,
    fill: "#a9bf5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.26 261.94l1258.16.31-.15 612.68-1258.16-.31.15-612.68m-2-2v2l-.15 612.68v2h2l1258.16.31h2v-2l.14-612.68v-2h-2l-1258.16-.31z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Haus_hinten_links"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fasade",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 299.95,
    x: -263.18,
    y: 103.02,
    fill: "#f2ab80",
    transform: "rotate(-180 -32.315 252.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 84.34,
    x: -263.18,
    y: 318.63,
    fill: "#ca9072",
    transform: "rotate(-180 -32.315 360.795)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "parkingBikeIncreased_after_svg__Tuer",
    d: "M-77.52 225.69h97.78v128.2a48.86 48.86 0 01-48.86 48.86h-.06a48.86 48.86 0 01-48.86-48.86v-128.2z",
    className: "parkingBikeIncreased_after_svg__cls-7",
    transform: "rotate(180 -28.63 314.215)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 126.61,
    height: 20.25,
    x: -91.8,
    y: 382.72,
    fill: "#9a9a9a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "rotate(-180 -28.49 392.845)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.76,
    height: 77.06,
    x: 49.86,
    y: 167.63,
    fill: "#7fc3ca",
    transform: "rotate(-180 82.24 206.155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4 167.63v-5.26a3.23 3.23 0 00-3.22-3.23H48.3a3.23 3.23 0 00-3.23 3.23V249.94a3.23 3.23 0 003.22 3.23h67.88a3.23 3.23 0 003.23-3.23v-5.26h.05v-77.05zm-4.78 34.28h-30v-34.28h30zm-34.79-34.28v34.28h-30v-34.28zm-30 42.77h30v34.28h-30zm34.78 34.28V210.4h30v34.28z",
    className: "parkingBikeIncreased_after_svg__cls-7"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#555",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "-276.34 107.2 -29.58 -85.41 217.85 107.2 -276.34 107.2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Haus_hinten_rechts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 610.94,
    height: 208.63,
    x: 423.96,
    y: 98.14,
    className: "parkingBikeIncreased_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.89 99.14v206.64H425V99.14h608.93m2-2H423v210.64h612.93V97.14z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 174.46,
    height: 208.63,
    x: 423.96,
    y: 98.14,
    className: "parkingBikeIncreased_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.42 99.14v206.64H425V99.14h172.42m2-2H423v210.64h176.42V97.14z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.11,
    height: 158.04,
    x: 441.59,
    y: 114.15,
    className: "parkingBikeIncreased_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.39 272.19 485.39 197.92 441.59 197.92 441.59 188.41 485.39 188.41 485.39 114.15 494.9 114.15 494.9 188.41 538.7 188.41 538.7 197.92 494.9 197.92 494.9 272.19 485.39 272.19",
    className: "parkingBikeIncreased_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.9 115.15v74.26h43.8v7.51h-43.8v74.27h-7.51v-74.27h-43.8v-7.51h43.8v-74.26h7.51m2-2h-11.51v74.26h-43.8v11.51h43.8v74.27h11.51v-74.27h43.8v-11.51h-43.8v-74.26z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.11,
    height: 158.04,
    x: 834.4,
    y: 114.15,
    className: "parkingBikeIncreased_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "878.2 272.66 878.2 197.92 834.4 197.92 834.4 188.41 878.2 188.41 878.2 114.14 887.71 114.14 887.71 188.41 932 188.41 932 197.92 887.71 197.92 887.71 272.66 878.2 272.66",
    className: "parkingBikeIncreased_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.72 115.14v74.27H931v7.51h-44.28v74.74h-7.52v-74.74h-43.81v-7.51h43.81v-74.27h7.52m2-2H877.2v74.26h-43.8v11.51h43.8v74.74h11.51v-74.73H933v-11.51h-44.29v-74.26z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89.32,
    height: 158.04,
    x: 946.32,
    y: 114.15,
    className: "parkingBikeIncreased_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.51,
    height: 156.04,
    x: 990.13,
    y: 115.15,
    className: "parkingBikeIncreased_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.64 116.15v154h-7.51v-154h7.51m2-2h-11.51v158h11.51v-158z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87.36,
    height: 9.51,
    x: 947.28,
    y: 188.41,
    className: "parkingBikeIncreased_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.65 189.41v7.51h-85.37v-7.51h85.37m2-2h-89.37v11.51h89.37v-11.51z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.45,
    height: 181.24,
    x: 652.97,
    y: 125.54,
    className: "parkingBikeIncreased_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.42 126.54v179.24H654V126.54h155.42m2-2H652v183.24h159.42V124.54z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 125.61,
    height: 170.11,
    x: 667.81,
    y: 136.66,
    className: "parkingBikeIncreased_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.42 137.66v168.12H668.81V137.66h123.61m2-2H666.81v172.12h127.61V135.66z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 159.83,
    x: 691.69,
    y: 146.51,
    className: "parkingBikeIncreased_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "729.56 306.78 729.56 265.58 691.69 265.58 691.69 261.43 729.56 261.43 729.56 223.54 691.69 223.54 691.69 219.38 729.56 219.38 729.56 181.33 691.69 181.33 691.69 177.17 729.56 177.17 729.56 146.5 733.83 146.5 733.83 177.17 771.69 177.17 771.69 181.33 733.83 181.33 733.83 219.38 771.69 219.38 771.7 223.54 733.83 223.54 733.83 261.43 771.69 261.43 771.69 265.58 733.83 265.58 733.83 306.78 729.56 306.78",
    className: "parkingBikeIncreased_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.83 147.5v30.67h37.86v2.16h-37.86v40h37.87v2.16h-37.87v39.89h37.87v2.15h-37.87v41.2h-2.27v-41.2h-37.87v-2.15h37.87v-39.84h-37.87v-2.16h37.87v-40h-37.88v-2.16h37.88V147.5h2.27m2-2h-6.27v30.68h-37.87v6.14h37.87v36.07h-37.87v6.15h37.87v35.89h-37.87v6.15h37.87v41.2h6.27v-41.2h37.86v-6.15h-37.86v-35.89h37.86v-6.15h-37.86v-36.07h37.86v-6.14h-37.86V145.5z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 654.41,
    x2: 668.27,
    y1: 126.37,
    y2: 136.76,
    className: "parkingBikeIncreased_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 809.25,
    x2: 792.71,
    y1: 126.84,
    y2: 137.05,
    className: "parkingBikeIncreased_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b4b45",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "1231.77 53.23 907.93 -56.73 422.96 97.14 1232.05 97.14 1231.77 53.23"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Baum"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Baum-2",
    "data-name": "Baum"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 322.45,
    cy: 134.41,
    r: 67.07,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.68 135.69a67.07 67.07 0 0167.07-67.07c1.53 0 3.06.06 4.57.16a67.08 67.08 0 10-18.44 132.55 67.09 67.09 0 01-53.2-65.64z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M313.5 331.14a3.68 3.68 0 01-2.65-1.13 3.49 3.49 0 01-1-2.6l10.69-155.82-12-12.05a1.4 1.4 0 011-2.39 1.47 1.47 0 01.61.14l11 5.35 1.57-22.79.09-1.84a3.49 3.49 0 017-.13l1 14.08 11-5.82h.56a2.21 2.21 0 012.1 1.53 2.18 2.18 0 01-.76 2.48l-11.81 8.53 10.78 168.62a3.48 3.48 0 01-.91 2.66 3.67 3.67 0 01-2.7 1.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.34 135.69a2.41 2.41 0 012.48 2.28l1.18 15.59 12.21-6.46a.93.93 0 01.23 0 1.24 1.24 0 01.73 2.22l-12.23 8.83 10.78 169.24a2.59 2.59 0 01-2.62 2.77h-25.6a2.59 2.59 0 01-2.62-2.68l10.73-156.25-12.35-12.38a.4.4 0 01.28-.68.38.38 0 01.17 0l12.38 6 1.67-24.26.09-1.86a2.42 2.42 0 012.49-2.37m0-2a4.4 4.4 0 00-4.49 4.26l-.09 1.87-1.46 21.27-9.71-4.7a2.44 2.44 0 00-1-.24 2.4 2.4 0 00-1.7 4.09L319.55 172l-10.66 155.32a4.47 4.47 0 001.24 3.38 4.69 4.69 0 003.37 1.44h25.57a4.67 4.67 0 003.44-1.51 4.54 4.54 0 001.17-3.44L333 159.11l11.34-8.19a3.24 3.24 0 00-1.9-5.84 2.9 2.9 0 00-.58 0l-.31.05-.28.15-9.5 5-.92-12.54a4.44 4.44 0 00-4.48-4.13z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "parkingBikeIncreased_after_svg__cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.06 154.85l13.43-7.11a1.2 1.2 0 00-1.31-.64L330 153.56zM324.54 165.36l1.74-25.44.1-1.86a2.38 2.38 0 011.23-2.05 2.51 2.51 0 00-3.76 2.05l-.09 1.86-1.66 24.26zM313.41 327.46l10.73-156.25-11.65-11.68-2.78-1.34a.4.4 0 00-.45.64l12.35 12.38-10.73 156.25a2.59 2.59 0 002.62 2.68h2.5a2.59 2.59 0 01-2.59-2.68z",
    className: "parkingBikeIncreased_after_svg__cls-20"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Haus_vorne"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376.86,
    height: 486.55,
    x: 854.91,
    y: 204.36,
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "1231.77 -97.63 1052.5 -97.63 854.69 204.7 1231.77 204.7 1231.77 -97.63"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 188.19,
    height: 322.86,
    x: 666.72,
    y: 368.05,
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "664.99 368.05 854.91 368.05 854.91 251.56 854.23 251.56 664.99 368.05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fenster-2",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.99,
    height: 113.99,
    x: 703.82,
    y: 409.27,
    className: "parkingBikeIncreased_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.07 402.52V530h127.49V402.52zm6.75 6.75h52.47v54h-52.47zm0 114v-54h52.47v54zm114 0h-55.59v-54h55.58zm0-60h-55.59v-54h55.58z",
    className: "parkingBikeIncreased_after_svg__cls-26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fenster-3",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1230.87 455.53 1053.99 455.53 1053.99 274.17 1230.75 274.17 1230.87 455.53",
    className: "parkingBikeIncreased_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1230.82 651.88 1053.99 651.88 1053.99 470.52 1230.86 470.52 1230.82 651.88",
    className: "parkingBikeIncreased_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.92 360.12v-85.95h84.8v-10.74h-188.47v399.19h188.52v-10.74h-84.85v-86h84.85v-9.46h-84.85v-86h84.85v-14.99h-84.85v-85.85h84.83v-9.46zm-9.46 291.76H1054v-86h83.47zm0-95.41H1054v-86h83.47zM1054 274.17h83.47v85.95H1054zm0 95.41h83.47v85.95H1054z",
    className: "parkingBikeIncreased_after_svg__cls-26"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M1062.63 812.17h-3.09c-18.15 0-32.91-9.38-32.91-20.9 0-9.42 9.79-17.53 23.74-20.07-3.72-3.45-5.73-7.55-5.73-11.8 0-9.42 9.66-17.51 23.71-20.07a13.28 13.28 0 01-.61-4c0-10.2 11.21-18.7 26.84-20.52.92-11 15.31-19.78 32.86-19.78a52 52 0 018.88.76c6.13-5.69 16.2-9.07 27.16-9.07a47.67 47.67 0 0117.55 3.2c5.62-5 14.59-8.21 24.32-8.66 6.1-5.85 16.29-9.33 27.42-9.33 17.68 0 32.14 8.9 32.88 20 11.18 1.74 20.19 7.18 23.52 14.17 15.81 0 29 6.93 32.15 16.63 15.65.23 28.61 7.21 31.5 16.91 13.13 2.94 21.88 10.78 21.88 19.7 0 5-2.64 9.6-7.51 13.33 10.84 3.56 17.67 10.62 17.67 18.54 0 9.52-10.11 17.83-24.59 20.21h-.12l-295.92.67a15.85 15.85 0 01-1.6.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.77 673.4c17.35 0 31.41 8.69 31.41 19.41v.41c11.84 1.52 21.21 7.17 24 14.4h.93c15.82 0 28.88 7.23 31 16.64h.36c15.85 0 28.92 7.26 31.07 16.68 12.53 2.55 21.59 9.83 21.59 18.43 0 5.44-3.65 10.36-9.5 13.88 11.52 2.88 19.66 9.84 19.66 18 0 9-9.91 16.53-23.34 18.73l-295.86.67c-.52 0-1 .07-1.53.07-1 0-2-.07-3.09-.07-17.35 0-31.41-8.69-31.41-19.4 0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.79 0-9.2 10.36-16.88 24.25-18.88a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.71 14.07-19.4 31.41-19.4a49.48 49.48 0 019.36.88c5.54-5.51 15.4-9.19 26.68-9.19a45.78 45.78 0 0117.86 3.45c5.27-5.1 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3m0-3c-11.26 0-21.63 3.48-28 9.36-9.6.54-18.17 3.55-24 8.4a49.72 49.72 0 00-17.25-3c-11 0-21.19 3.33-27.63 9a53 53 0 00-8.41-.66c-18 0-32.38 8.58-34.21 19.94-15.79 2.21-27 11.15-27 21.86a14.75 14.75 0 00.27 2.8c-13.92 3-23.37 11.43-23.37 21.23a16.78 16.78 0 004.28 10.89c-13.23 3.2-22.29 11.45-22.29 21 0 12.56 15.11 22.4 34.41 22.4h3.09c.53 0 1.15 0 1.67-.07l295.73-.67h.48c15.22-2.5 25.85-11.42 25.85-21.69 0-8-6.2-15.07-16.23-19.07 3.95-3.7 6.07-8.11 6.07-12.8 0-9.45-8.85-17.73-22.22-21-3.48-9.66-16.22-16.59-31.59-17.11-3.8-9.58-16.79-16.38-32.29-16.65-3.72-6.87-12.24-12-23.07-14-1.64-11.5-16.1-20.22-34.26-20.22z",
    className: "parkingBikeIncreased_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "parkingBikeIncreased_after_svg__cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1042.12 800.21c0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.8 0-9.19 10.36-16.87 24.25-18.87a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.72 14.07-19.4 31.42-19.4a50.22 50.22 0 019.35.87c5.55-5.51 15.4-9.19 26.68-9.19a45.6 45.6 0 0117.86 3.46c5.27-5.11 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3a47.75 47.75 0 0114.44 2.18c-5-6.6-15.84-11.19-28.43-11.19-11.35 0-21.26 3.73-26.78 9.3-10.37.37-19.38 3.84-24.65 8.94a45.78 45.78 0 00-17.86-3.45c-11.28 0-21.14 3.68-26.68 9.19a49.48 49.48 0 00-9.36-.88c-17.34 0-31.41 8.69-31.41 19.4v.23c-15.16 1.38-26.81 9.43-26.81 19.17a12.6 12.6 0 001.15 5.15c-13.89 2-24.25 9.68-24.25 18.88 0 4.9 3 9.37 7.84 12.79-14.69 1.62-25.85 9.54-25.85 19.08 0 7.5 6.89 14 17 17.22a13.55 13.55 0 01-3.01-8.21z",
    className: "parkingBikeIncreased_after_svg__cls-20"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "parkingBikeIncreased_after_svg__Weg",
    fill: "#eec6a2",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M703.59 985.61C561 973.73 420.76 950.89 327.21 867.27c-53-47.4-72.92-85.24-88.89-115.64-14.84-28.27-25.57-48.69-62.72-75.48C97.75 620 9 614.61-85 608.9c-97.67-5.94-196.2 5.82-292.88 35l-25.68-85.21c106.77-32.18 215.77-45.16 324-38.58 102.5 6.23 208.49 12.67 307.25 83.9 54.14 39 72.09 73.23 89.46 106.28 14.58 27.77 28.36 54 69.4 90.67 79 70.63 185.87 113.38 309 123.65A564.54 564.54 0 00845.1 917"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Laterne"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.4,
    height: 257.22,
    x: 104.83,
    y: 368.37,
    className: "parkingBikeIncreased_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.03,
    cy: 713.4,
    className: "parkingBikeIncreased_after_svg__cls-29",
    rx: 29.71,
    ry: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.94,
    height: 87.81,
    x: 94.06,
    y: 625.59,
    className: "parkingBikeIncreased_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.23 383.36 138.25 312 120.01 286.55 100.37 286.55 83.29 312 104.83 383.36 99.88 393.87 119.68 393.87 115.34 383.36 115.23 383.36",
    className: "parkingBikeIncreased_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ececee",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M120.12 320.3H99.94a6.29 6.29 0 00-6.07 7.95l11 40.12h10.4l11-40.12a6.29 6.29 0 00-6.15-7.95z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fahrrad3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.74,
    height: 4.4,
    x: 511.72,
    y: 589.84,
    className: "parkingBikeIncreased_after_svg__cls-31",
    rx: 1.82
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "505.39 612.52 502.92 610.34 516.87 592.04 520.21 592.01 505.39 612.52",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#857d7a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    points: "433.55 613.05 405.44 585.57 408.47 582.76 436.58 610.25 433.55 613.05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.33,
    cy: 614.15,
    r: 12.63,
    className: "parkingBikeIncreased_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.36 610.61c.88 3.63-.41 16.37-11.93 16.17-5.79-.1-73.79-4.75-71.56-16.17 1.57-8.09 47.61-9.1 71.56-9.1 0 0 9.7 0 11.93 9.1z",
    className: "parkingBikeIncreased_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.15 652.29A41.88 41.88 0 11478 610.41a41.92 41.92 0 01-41.85 41.88zm0-79.75A37.88 37.88 0 10474 610.41a37.91 37.91 0 00-37.85-37.87z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "587.03 609.9 570.44 574.26 574.27 572.71 590.86 608.35 587.03 609.9",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.11 656a45.55 45.55 0 1132.2-13.34 45.25 45.25 0 01-32.2 13.34zm0-87.13a41.59 41.59 0 1041.59 41.59 41.63 41.63 0 00-41.59-41.64zM589.34 656a45.55 45.55 0 1132.2-13.34 45.25 45.25 0 01-32.2 13.34zm0-87.13a41.59 41.59 0 1041.59 41.59 41.63 41.63 0 00-41.59-41.64z",
    className: "parkingBikeIncreased_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.73 562a49.95 49.95 0 00-36.06 2.12l-3.43-8.43a2 2 0 00-.45-1.93 2.06 2.06 0 00-.48-.37l-2.09-5.14a2 2 0 00-.06-1.34l-7.07-17.18a2 2 0 10-3.66 1.5l6 14.56-71.43 2.65-4.43-15.64a2 2 0 00-3.81 1.08l4.59 16.12-15.79 20a49.77 49.77 0 00-66 4.24 50.23 50.23 0 00-14.65 35.62 2.48 2.48 0 104.95 0A45.31 45.31 0 01436 564.47a44.61 44.61 0 0127.52 9.47l-29 36.76a2 2 0 001.45 3.2l64.29 3.23h.76l.14-.06.14-.08.15-.1.15-.13 61.4-58.57 3 7.27A50.49 50.49 0 00539.4 610a2.48 2.48 0 105 0 45.31 45.31 0 0145.08-45.43 44.56 44.56 0 0113.78 2.16 2.47 2.47 0 001.52-4.71zm-138.24 14.5A45.5 45.5 0 01481 609.9a2.48 2.48 0 001.9 2.41l-43-2.17zm17.36 35.85a2.46 2.46 0 002.15-2.45 50.23 50.23 0 00-14.65-35.62c-.57-.58-1.16-1.14-1.76-1.69l14-17.71 14.18 58.17zm17.56-1l-14.39-59 72.48-2.7 1.87 4.61z",
    className: "parkingBikeIncreased_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589.34,
    cy: 610.41,
    r: 3.94,
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.7 651.83A41.88 41.88 0 11631.57 610a41.93 41.93 0 01-41.87 41.83zm0-79.75A37.88 37.88 0 10627.57 610a37.92 37.92 0 00-37.87-37.92z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.23 538.4a5 5 0 01-2.65-2.49c-.84-1.85-.43-4-.1-5.72.28-1.43 1.08-5.62 4.08-8.21a8.91 8.91 0 014.94-2 12.78 12.78 0 018.54 1.37c3.47 2 3.8 4.29 7.48 5.54a14 14 0 003.63.56c4.72.39 7.41-.72 12.72-.25 3 .27 3.88.77 4.37 1.74.84 1.69.22 4.35-.67 6-1.64 3-4.72 3.48-8 3.86-5.51.63-8.32.56-16.24 1-2.4.14-2.67.21-5.22.33-4.52.25-8.72.29-12.88-1.73z",
    className: "parkingBikeIncreased_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.58 496.84a25.79 25.79 0 00-1.5 3.27l-7.91 27.25-21.09 16.26c-1.44 1-2.8 1.19-1.76 2.63.62.88.58.86 1.58.86a3.25 3.25 0 001.87-.6l20.58-14.77 2.79 6.56 4.1-1.74-3.9-9.17 7.46-26.59c.48-1.71-3.48-2.71-2.22-3.96z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.33,
    cy: 614.35,
    r: 3.94,
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.34,
    height: 3.23,
    x: 488.01,
    y: 622.33,
    className: "parkingBikeIncreased_after_svg__cls-32",
    transform: "rotate(-64.16 498.728 623.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.98,
    height: 5.86,
    x: 486.45,
    y: 631.43,
    className: "parkingBikeIncreased_after_svg__cls-31",
    rx: 2.43
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.19,
    x2: 559.96,
    y1: 509.13,
    y2: 497.04,
    className: "parkingBikeIncreased_after_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.1 510.88l-4.88-2.24 2-9.63c.42-2 1.85-3.08 3.2-2.46 1.35.61 2.1 2.72 1.68 4.7z",
    className: "parkingBikeIncreased_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 535.77,
    x2: 529.08,
    y1: 539.26,
    y2: 545.37,
    className: "parkingBikeIncreased_after_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.42 537.54l2.05 4.71-7.45 5.1c-1.53 1-3.23.84-3.79-.45-.57-1.3.21-3.21 1.75-4.26z",
    className: "parkingBikeIncreased_after_svg__cls-35"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fahrrad2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.81,
    height: 4.42,
    x: 510.25,
    y: 603.9,
    className: "parkingBikeIncreased_after_svg__cls-31",
    rx: 1.83
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.89 626.72 501.4 624.53 515.44 606.12 518.8 606.09 503.89 626.72",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.62 627.25 403.33 599.6 406.38 596.78 434.67 624.43 431.62 627.25",
    className: "parkingBikeIncreased_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.81,
    cy: 628.36,
    r: 12.71,
    className: "parkingBikeIncreased_after_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.92 624.8c.89 3.65-.41 16.47-12 16.27-5.83-.1-74.24-4.78-72-16.27 1.58-8.14 47.9-9.15 72-9.15 0 0 9.76 0 12 9.15z",
    className: "parkingBikeIncreased_after_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.23 666.73a42.13 42.13 0 1142.13-42.13 42.18 42.18 0 01-42.13 42.13zm0-80.24a38.11 38.11 0 1038.11 38.11 38.16 38.16 0 00-38.11-38.11z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "586.03 624.09 569.34 588.23 573.19 586.66 589.88 622.52 586.03 624.09",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.19 670.41a45.82 45.82 0 1132.4-13.41 45.55 45.55 0 01-32.4 13.41zm0-87.66A41.84 41.84 0 10476 624.59a41.89 41.89 0 00-41.81-41.84zM588.35 670.41a45.82 45.82 0 1132.4-13.41 45.51 45.51 0 01-32.4 13.41zm0-87.66a41.84 41.84 0 1041.84 41.84 41.89 41.89 0 00-41.84-41.84z",
    className: "parkingBikeIncreased_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.83 575.87a50.34 50.34 0 00-36.28 2.13l-3.44-8.47a2 2 0 00-.46-1.95 2.06 2.06 0 00-.48-.37l-2.11-5.21a2 2 0 000-1.34l-7.12-17.29a2 2 0 00-3.68 1.51l6 14.65-71.85 2.69-4.46-15.73a2 2 0 10-3.82 1.08l4.6 16.26-15.9 20.17a50.07 50.07 0 00-66.39 4.27 50.55 50.55 0 00-14.74 35.84 2.49 2.49 0 005 0 45.59 45.59 0 0145.3-45.74 44.89 44.89 0 0127.68 9.53l-29.19 37a2 2 0 001.51 3.2l64.67 3.26H499.6l.13-.07h.05l.15-.1a.93.93 0 00.15-.13l61.67-58.74 3 7.31a50.87 50.87 0 00-26.68 44.78 2.49 2.49 0 005 0 45.59 45.59 0 0145.36-45.72 45 45 0 0113.85 2.18 2.49 2.49 0 001.53-4.74zm-139.08 14.61a45.75 45.75 0 0114.64 33.61 2.49 2.49 0 001.91 2.41l-43.3-2.17zm17.47 36.07a2.48 2.48 0 002.15-2.46 50.54 50.54 0 00-14.73-35.84c-.58-.59-1.17-1.15-1.78-1.7l14.07-17.83 14.27 58.53zm17.66-1l-14.47-59.37 72.92-2.73 1.88 4.64z",
    className: "parkingBikeIncreased_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.35,
    cy: 624.59,
    r: 3.97,
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.71 666.26a42.13 42.13 0 1142.13-42.12 42.17 42.17 0 01-42.13 42.12zm0-80.23a38.11 38.11 0 1038.11 38.11A38.15 38.15 0 00588.71 586z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.47 547.28a5.26 5.26 0 01-2.8-2.62c-.88-1.95-.46-4.19-.1-6 .29-1.5 1.13-5.93 4.3-8.66a9.29 9.29 0 015.21-2.1 13.39 13.39 0 019 1.44c3.66 2.06 4 4.52 7.89 5.84a14.47 14.47 0 003.83.59c5 .41 7.81-.76 13.42-.26 3.13.28 4.09.81 4.6 1.84.89 1.77.23 4.58-.7 6.3-1.73 3.19-5 3.67-8.41 4.07-5.81.67-8.78.59-17.13 1.09-2.53.15-2.81.22-5.5.35-4.79.21-9.23.26-13.61-1.88z",
    className: "parkingBikeIncreased_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.41 510.34a23.78 23.78 0 00-1.51 3.29l-8 27.41-21.18 16.36c-1.45 1-2.81 1.2-1.77 2.65.63.88.59.86 1.59.86a3.19 3.19 0 001.88-.61l20.71-14.85 2.81 6.6 4.12-1.75-3.93-9.22 7.52-26.76c.48-1.72-3.51-2.73-2.24-3.98z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.81,
    cy: 628.56,
    r: 3.97,
    className: "parkingBikeIncreased_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.47,
    height: 3.25,
    x: 486.4,
    y: 636.59,
    className: "parkingBikeIncreased_after_svg__cls-32",
    transform: "rotate(-64.16 497.186 638.237)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.08,
    height: 5.9,
    x: 484.83,
    y: 645.75,
    className: "parkingBikeIncreased_after_svg__cls-31",
    rx: 2.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 555,
    x2: 558.79,
    y1: 522.7,
    y2: 510.54,
    className: "parkingBikeIncreased_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.93 524.46l-4.9-2.25 2.05-9.69c.42-2 1.86-3.1 3.22-2.48 1.35.62 2.11 2.74 1.68 4.73z",
    className: "parkingBikeIncreased_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534.45,
    x2: 527.72,
    y1: 553.02,
    y2: 559.16,
    className: "parkingBikeIncreased_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.1 551.29l2.06 4.73-7.49 5.13c-1.54 1.06-3.25.85-3.82-.45-.57-1.31.22-3.23 1.76-4.28z",
    className: "parkingBikeIncreased_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.56,
    x2: 483.15,
    y1: 626.47,
    y2: 626.59,
    className: "parkingBikeIncreased_after_svg__cls-39"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fahrrad1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.09,
    height: 5.55,
    x: 475.55,
    y: 605.3,
    className: "parkingBikeIncreased_after_svg__cls-31",
    rx: 2.3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.56 633.96 464.44 631.2 482.06 608.08 486.28 608.04 467.56 633.96",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.8 634.63 341.29 599.9 345.12 596.36 380.63 631.08 376.8 634.63",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464.96,
    cy: 636.01,
    r: 15.96,
    className: "parkingBikeIncreased_after_svg__cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.15 631.54c1.12 4.59-.51 20.69-15.07 20.43-7.31-.13-93.22-6-90.41-20.43 2-10.21 60.16-11.49 90.41-11.49 0 0 12.26 0 15.07 11.49z",
    className: "parkingBikeIncreased_after_svg__cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.09 684.19a52.9 52.9 0 1152.9-52.9 53 53 0 01-52.9 52.9zm0-100.75a47.86 47.86 0 1047.85 47.85 47.9 47.9 0 00-47.85-47.85z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "570.71 630.65 549.75 585.62 554.58 583.65 575.54 628.68 570.71 630.65",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 688.82A57.53 57.53 0 11420.72 672 57.16 57.16 0 01380 688.82zm0-110.07a52.54 52.54 0 1052.54 52.54A52.59 52.59 0 00380 578.75z",
    className: "parkingBikeIncreased_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    stroke: "#343a50",
    strokeLinejoin: "round",
    d: "M573.63 688.82A57.53 57.53 0 11614.31 672a57.16 57.16 0 01-40.68 16.82zm0-110.07a52.54 52.54 0 1052.54 52.54 52.6 52.6 0 00-52.54-52.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.06 570.1a63.1 63.1 0 00-45.55 2.68l-4.33-10.64a2.5 2.5 0 00-.58-2.45 2.44 2.44 0 00-.6-.47l-2.64-6.49a2.52 2.52 0 00-.07-1.69l-8.94-21.71a2.5 2.5 0 00-4.62 1.9l7.57 18.39-90.23 3.38-5.59-19.75a2.5 2.5 0 00-4.81 1.36l5.78 20.39-19.94 25.26a62.89 62.89 0 00-83.37 5.37 63.46 63.46 0 00-18.5 45 3.13 3.13 0 006.25 0c0-31.65 25.55-57.41 57-57.41a56.37 56.37 0 0134.76 12L378 631.65a2.5 2.5 0 001.83 4l81.17 4.13h.72l.17-.05h.08l.17-.07h.07l.17-.1h.06l.18-.13.2-.16 77.45-73.76 3.73 8.99a63.83 63.83 0 00-33.51 56.22 3.13 3.13 0 106.26 0c0-31.65 25.55-57.4 57-57.4a56.52 56.52 0 0117.4 2.73 3.13 3.13 0 101.92-5.95zm-174.64 18.35a57.5 57.5 0 0118.38 42.2 3.11 3.11 0 002.4 3L384.87 631zm21.92 45.29a3.12 3.12 0 002.71-3.09 63.46 63.46 0 00-18.5-45c-.73-.74-1.47-1.45-2.23-2.14L440 561.13l17.92 73.5zm22.19-1.24l-18.18-74.56 91.58-3.42 2.36 5.83z",
    className: "parkingBikeIncreased_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573.63,
    cy: 631.29,
    r: 4.98,
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.07 683.61a52.9 52.9 0 1152.9-52.9 53 53 0 01-52.9 52.9zm0-100.75a47.85 47.85 0 1047.85 47.85 47.91 47.91 0 00-47.85-47.85z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.63 536.93a5.5 5.5 0 01-2.9-2.71c-.91-2-.47-4.33-.1-6.25.3-1.55 1.17-6.13 4.45-9a9.68 9.68 0 015.39-2.17 13.84 13.84 0 019.32 1.5c3.78 2.13 4.14 4.67 8.15 6a15.41 15.41 0 004 .61c5.15.42 8.08-.79 13.88-.27 3.25.29 4.23.84 4.76 1.9.92 1.83.24 4.73-.72 6.51-1.79 3.3-5.15 3.8-8.7 4.21-6 .69-9.08.62-17.71 1.13-2.62.15-2.91.22-5.69.37-5.01.33-9.6.38-14.13-1.83z",
    className: "parkingBikeIncreased_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 487.81a28.52 28.52 0 00-1.9 4.13l-10 34.42-26.62 20.54c-1.81 1.31-3.52 1.52-2.22 3.33.8 1.11.74 1.08 2 1.08a4 4 0 002.35-.76l26-18.65 3.53 8.29 5.17-2.2-4.93-11.58 9.43-33.6c.63-2.16-4.38-3.43-2.81-5z",
    className: "parkingBikeIncreased_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464.96,
    cy: 636.27,
    r: 4.98,
    fill: "#857d7a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.96,
    height: 4.09,
    x: 445.6,
    y: 646.35,
    className: "parkingBikeIncreased_after_svg__cls-32",
    transform: "rotate(-64.16 459.129 648.415)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.45,
    height: 7.41,
    x: 443.63,
    y: 657.85,
    className: "parkingBikeIncreased_after_svg__cls-31",
    rx: 3.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 531.74,
    x2: 536.5,
    y1: 503.33,
    y2: 488.06,
    className: "parkingBikeIncreased_after_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.68 505.54l-6.16-2.83 2.58-12.16c.53-2.5 2.34-3.9 4-3.11 1.7.78 2.65 3.44 2.12 5.94z",
    className: "parkingBikeIncreased_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 505.94,
    x2: 497.48,
    y1: 541.4,
    y2: 549.12,
    className: "parkingBikeIncreased_after_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.5 539.23l2.59 5.94-9.41 6.45c-1.93 1.32-4.08 1.07-4.8-.57-.71-1.65.28-4 2.22-5.38z",
    className: "parkingBikeIncreased_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.45,
    x2: 441.83,
    y1: 633.65,
    y2: 633.82,
    className: "parkingBikeIncreased_after_svg__cls-43"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_after_svg__Fahrradstellplatz"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.34,
    height: 251.36,
    x: 644.37,
    y: 439.56,
    fill: "#f9ffff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9ffff",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M258.79 382.36c41.55-10.48 93.08-16.44 147.14-16.44a701.49 701.49 0 0179.32 4.37c34.7 4 66.46 10.54 93.06 19.45C619.57 403.54 644.2 422 644.2 439h21.74c0-14.43-9.58-27.95-25.05-40.18-13.41-10.62-32.33-20.05-56.23-28.05-27.75-9.29-60.74-16.16-96.68-20.29a721.88 721.88 0 00-82.05-4.56c-52.63 0-103.21 5.59-145.31 15.52z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.99,
    x2: 488.87,
    y1: 350.95,
    y2: 370.71,
    className: "parkingBikeIncreased_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 574.64,
    x2: 568.99,
    y1: 367.59,
    y2: 385.61,
    className: "parkingBikeIncreased_after_svg__cls-48"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.69,
    x2: 433.69,
    y1: 334.19,
    y2: 346.42,
    className: "parkingBikeIncreased_after_svg__cls-49"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.96,
    x2: 266.96,
    y1: 349.5,
    y2: 359.41,
    className: "parkingBikeIncreased_after_svg__cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M258.94 351.52c42.33-11.1 95.15-17.69 152.45-17.69 139.14 0 252.84 42.62 252.84 90.56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 592.43,
    x2: 592.43,
    y1: 362.21,
    y2: 373.49,
    fill: "#a9bf5c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.34
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingBikeIncreasedafter);
export default __webpack_public_path__ + "static/media/parkingBikeIncreased.after.9c12fcb8.svg";
export { ForwardRef as ReactComponent };